import React from 'react';
import { LoginContainer } from '@/features/auth';

function Login() {
  return <LoginContainer />;
}

export default Login;
